import React, { FC } from 'react';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import {
  LEGAL_REACCEPTANCE_INTRO_BODY,
  LEGAL_REACCEPTANCE_INTRO_CTA,
  LEGAL_REACCEPTANCE_INTRO_HEADING,
  LEGAL_REACCEPTANCE_INTRO_STEP_1_SUB,
  LEGAL_REACCEPTANCE_INTRO_STEP_1_TITLE,
  LEGAL_REACCEPTANCE_INTRO_STEP_2_SUB,
  LEGAL_REACCEPTANCE_INTRO_STEP_2_TITLE
} from 'containers/legal-reacceptance/constants';

export interface LegalReacceptanceIntroOverviewScreenProps {
  onGetStarted: () => void;
}

const LegalReacceptanceIntroOverviewScreen: FC<LegalReacceptanceIntroOverviewScreenProps> = ({ onGetStarted }) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-6 p-8 pb-10">
      <div className="flex min-h-0 flex-1 flex-col gap-6">
        <div className="flex flex-col gap-3">
          <h1 className="text-xl font-bold leading-tight text-primaryText">{LEGAL_REACCEPTANCE_INTRO_HEADING}</h1>
          <p className="text-sbase text-primaryText">{LEGAL_REACCEPTANCE_INTRO_BODY}</p>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex gap-3 rounded-lg border border-borderGray bg-[#f0f6ff] p-4">
            <div
              className="flex h-8 w-8 shrink-0 items-center justify-center 
rounded-full bg-secondary text-sm font-bold text-white">
              1
            </div>
            <div className="flex min-w-0 flex-col gap-1">
              <p className="text-sbase font-bold text-primaryText">{LEGAL_REACCEPTANCE_INTRO_STEP_1_TITLE}</p>
              <p className="text-sbase text-primaryText">{LEGAL_REACCEPTANCE_INTRO_STEP_1_SUB}</p>
            </div>
          </div>
          <div className="flex gap-3 rounded-lg border border-borderGray bg-[#f0f6ff] p-4">
            <div
              className="flex h-8 w-8 shrink-0 items-center justify-center 
      rounded-full bg-secondary text-sm font-bold text-white">
              2
            </div>
            <div className="flex min-w-0 flex-col gap-1">
              <p className="text-sbase font-bold text-primaryText">{LEGAL_REACCEPTANCE_INTRO_STEP_2_TITLE}</p>
              <p className="text-sbase text-primaryText">{LEGAL_REACCEPTANCE_INTRO_STEP_2_SUB}</p>
            </div>
          </div>
        </div>
      </div>
      <CustomButton
        type={ButtonType.PRIMARY}
        onClick={onGetStarted}
        id="legal-reacceptance-get-started-btn"
        className="h-12 w-full shrink-0"
        childrenContainerStyles="text-17px font-semibold">
        {LEGAL_REACCEPTANCE_INTRO_CTA}
      </CustomButton>
    </div>
  );
};

export default LegalReacceptanceIntroOverviewScreen;
